export default __webpack_public_path__ + "static/media/blueeyes5.699ca31d.jpg";